import React from 'react';
import './workflowEditor.css';

import { Form } from 'react-bootstrap';

import DynamicAttributeForm from '../../../../global/dynamic-attribute-form/DynamicAttributeForm';
import { SubworkflowEditor } from './SubworkflowEditor';
import Heading from '@amzn/meridian/heading';

export const WorkflowDisplay = ({
  workflowData,
  workflowGraphs,
  workflowSelectionAttributes,
  editable,
  onGraphUpdated,
  onWorkflowAttributesChanged,
  onDeleteSubworkflow,
  onPromoteToProduction,
  onSave,
}) => {
  return (
    <div className="w-100 h-100 p-1 d-flex flex-column overflow-y-auto">
      <Form.Group>
        <Heading level={2} tag="label" htmlFor="workflow-selection-attributes">
          Selection attributes
        </Heading>
        <DynamicAttributeForm
          id="workflow-selection-attributes"
          value={workflowSelectionAttributes}
          onChange={onWorkflowAttributesChanged}
          disabled={!editable}
        />
      </Form.Group>
      <div>
        {workflowData?.subWorkflows &&
          workflowData?.subWorkflows.map((subWorkflow, idx) => {
            return (
              <SubworkflowEditor
                workflowId={workflowData.workflowId}
                subWorkflow={subWorkflow}
                workflowGraph={workflowGraphs[idx]}
                key={subWorkflow.sourceLocale + '-' + subWorkflow.targetLocale}
                onDeleteSubworkflow={onDeleteSubworkflow}
                onGraphUpdated={onGraphUpdated}
                editable={editable}
                onPromoteToProd={onPromoteToProduction}
                onSave={onSave}
              />
            );
          })}
      </div>
    </div>
  );
};
